import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  CalendarModule as AngularCalendarModule,
  DateAdapter,
} from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { CalendarRoutingModule } from './calendar-routing.module';
import { CalendarComponent } from './calendar.component';
import { RmFilterModule } from '@web-frontend/shared/components/globals/rm-filter';
import { RomaToolTipModule } from '@web-frontend/shared/directives/roma-tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PermissionsModule } from '@web-frontend/shared/components/permissions';
import { I18nChild } from '@web-frontend/shared/i18n';
import { ModalEnableModuleComponent } from './modal-enable-module/modal-enable-module.component';

@NgModule({
  declarations: [CalendarComponent, ModalEnableModuleComponent],
  imports: [
    CommonModule,
    CalendarRoutingModule,
    I18nChild,
    RmFilterModule,
    RomaToolTipModule,
    CommonModule,
    AngularCalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    MatCheckboxModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinnerModule,
    PermissionsModule,
  ],
  exports: [CalendarComponent],
})
export class CalendarModule {}
